import React, { useEffect, useState, Fragment } from 'react';
import { TableContentForViewWeighmnet } from '../../../Common/Table/tableContent';
import $ from 'jquery';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import services from '../../services';
import { CommonEncryptParam } from '../../../../../utils/CommonParams';
import { useHistory } from 'react-router';
import { CommonDecryptParam } from '../../../../../utils/CommonParams';
import Tooltip from '@material-ui/core/Tooltip';

export function ViewWeightment(props) {

    let history = useHistory();
    const { data } = props.location;
    const contentRowNames = ["tagNo", "actualAmount", "grossAmount", "netAmount" ]
    const [supplierItemsDetils, setSupplierItemsDetils] = useState([]);
    const [imageList, setImageList] = useState([]);

    const encriptedText = props.match.params["id"];
    const id = (encriptedText !== undefined) ? CommonDecryptParam(encriptedText) : 0;

    useEffect(() => {
        trackPromise(
            getWeighmentData()
        )
    }, []);

    async function getWeighmentData() {
        destroyDataTable();
        const response = await services.GetSupplierItemDetails(id);
        setSupplierItemsDetils(response);

        const images = await services.GetImagesForWeighnItem(id);
        setImageList(images);

        createDataTable();
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    function onBackClicked() {
        history.goBack();
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div class="card">
                        <div className="card-header">
                            <div className="row">
                                <div className="col-md-10">
                                    <h5 className="title">Item Details</h5>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <Tooltip title="back">
                                            <button
                                                className="btn btn-info btn-md pull-right btn-nav"
                                                onClick={onBackClicked}>
                                                <i className="fas fa-arrow-left"></i>
                                            </button>
                                        </Tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            {imageList.map((x, i) => {
                                return <img key={i} src={x} width="250" height="250" className="p-2"/>
                            })}
                            <div className="table-responsive row-top-gap">
                                <table id="example" className="display dataTable no-footer">
                                    <thead>
                                        <tr>
                                            <th><b>Tag Number</b></th>
                                            <th><b>Actual Amount</b></th>
                                            <th><b>Gross Amount</b></th>
                                            <th><b>Net Amount</b></th>0
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <TableContentForViewWeighmnet
                                            data={supplierItemsDetils}
                                            hasEdit={false}
                                            contentRowNames={contentRowNames}
                                        />
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}